// extracted by mini-css-extract-plugin
module.exports = {"container":"DigitField_container__28rhL","field":"DigitField_field__3sJBo"};